"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGiftingFlowSteps = exports.useActiveStep = void 0;

var _reactRedux = require("react-redux");

var _react = require("react");

var _activeStep = require("../store/ui/activeStep/activeStep.selectors");

var _activeStep2 = require("../store/ui/activeStep/activeStep.reducer");

var useActiveStep = function useActiveStep() {
  return (0, _reactRedux.useSelector)(_activeStep.getActiveStep);
};

exports.useActiveStep = useActiveStep;

var useGiftingFlowSteps = function useGiftingFlowSteps() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var nextStep = (0, _reactRedux.useSelector)(_activeStep.getNextStep);
  var prevStep = (0, _reactRedux.useSelector)(_activeStep.getPrevStep);
  var setActiveStep = (0, _react.useCallback)(function (step) {
    dispatch((0, _activeStep2.setActiveStep)(step));
  }, [dispatch]);
  var goToNextStep = (0, _react.useCallback)(function () {
    dispatch((0, _activeStep2.setActiveStep)(nextStep));
  }, [dispatch, nextStep]);
  var goToPrevStep = (0, _react.useCallback)(function () {
    dispatch((0, _activeStep2.setActiveStep)(prevStep));
  }, [dispatch, prevStep]);
  return (0, _react.useMemo)(function () {
    return {
      useActiveStep,
      goToNextStep,
      goToPrevStep,
      setActiveStep
    };
  }, [goToNextStep, goToPrevStep, setActiveStep]);
};

exports.useGiftingFlowSteps = useGiftingFlowSteps;